import getOr from 'lodash/fp/getOr';
import { LocalStorage } from "./LocalStorage";

export class Comment {
  constructor(
    id,
    userName,
    userId,
    updateAt,
    comment,
    replies = [],
    totalReply,
    status
  ) {
    this.id = id;
    this.userName = userName;
    this.userId = userId;
    this.updateAt = updateAt;
    this.comment = comment;
    this.replies = replies;
    this.totalReply = totalReply;
    this.status = status;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Comment(
        input[this.COMMENT_ATTRIBUTE.ID],
        input[this.COMMENT_ATTRIBUTE.USERNAME],
        input[this.COMMENT_ATTRIBUTE.USER_ID],
        input[this.COMMENT_ATTRIBUTE.CREATED_AT],
        getOr("", `${this.COMMENT_ATTRIBUTE.COMMENT}`)(input),
        Comment.fromApiArray(input[this.COMMENT_ATTRIBUTE.REPLIES]),
        input[this.COMMENT_ATTRIBUTE.TOTAL_REPLY],
        input[this.COMMENT_ATTRIBUTE.STATUS] || this.STATUS_COMMENT.APPROVED,
      )
    }

    return new Comment();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Comment.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Comment.fromApiObject(input)];
    }

    return [];
  }

  isOwner() {
    return this.userId && this.userId + "" === LocalStorage.getUserId();
  }

  isApproved() {
    return this.status === Comment.STATUS_COMMENT.APPROVED;
  }

  isPending() {
    return this.status === Comment.STATUS_COMMENT.PENDING;
  }

  isDelete() {
    return this.status === Comment.STATUS_COMMENT.DELETE;
  }

  genParams(blogId) {
    let params = {};
    if (blogId) {
      params[Comment.PARAM_ATTRIBUTE.BLOG_ID] = blogId;
    }
    if (this.id) {
      params[Comment.PARAM_ATTRIBUTE.ID] = this.id;
    }
    if (this.comment) {
      params[Comment.PARAM_ATTRIBUTE.CONTENT] = {
        "text": this.comment
      }
    }
    return params;
  }

  static COMMENT_ATTRIBUTE = {
    ID: 'comment_id',
    USER_ID: 'user_id',
    USERNAME: 'user_name',
    CREATED_AT: 'created_at',
    COMMENT: 'content.text',
    REPLIES: 'replies',
    TOTAL_REPLY: 'totalReply',
    STATUS: 'status',
  }
  static PARAM_ATTRIBUTE = {
    ID: "comment_id",
    CONTENT: "content",
    BLOG_ID: "blog_article_id"
  }

  static STATUS_COMMENT = {
    PENDING: "pending",
    APPROVED: "approved",
    DELETE: "deleted"
  }
}